export const SELECTION_COLUMN_WIDTH = 49;
export const ROW_HEIGHT = 56;
export const ROW_HEIGHT_COMPACT = 40;

export const FIXED_NAME_COLUMN_ID = "Name";
export const FIXED_NAME_COLUMN_DEFAULT_WIDTH = 450;
export const FIXED_NAME_COLUMN = {
  name: FIXED_NAME_COLUMN_ID,
  id: FIXED_NAME_COLUMN_ID,
  title: FIXED_NAME_COLUMN_ID,
  width: FIXED_NAME_COLUMN_DEFAULT_WIDTH,
};

export const isColumnSortable = (metricName: string) => {
  if (
    metricName.startsWith("Forecasted ") ||
    metricName.startsWith("benchmark") ||
    metricName === FIXED_STATUS_COLUMN_ID
  ) {
    return false;
  }
  return true;
};

export const isColumnFilterable = (metricName: string) => {
  if (metricName.startsWith("benchmark")) {
    return false;
  } else if (metricName === FIXED_NAME_COLUMN_ID) {
    return false;
  }

  return true;
};

export const FIXED_STATUS_COLUMN_ID = "Status";
export const FIXED_STATUS_COLUMN_DEFAULT_WIDTH = 100;
export const FIXED_STATUS_COLUMN = {
  name: FIXED_STATUS_COLUMN_ID,
  id: FIXED_STATUS_COLUMN_ID,
  title: FIXED_STATUS_COLUMN_ID,
  width: FIXED_STATUS_COLUMN_DEFAULT_WIDTH,
};
